/* SOAR Homepage — scroll reveal (ported from reference). Guarded so it binds once
   even though every section links it. Observes any .reveal that isn't yet revealed. */
(function () {
  if (window.__soarHomeReveal) return;
  window.__soarHomeReveal = 1;
  function bind() {
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('on'); ro.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.soar-home .reveal:not(.on)').forEach(function (el) { ro.observe(el); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', bind); }
  else { bind(); }
  // Re-scan when sections are re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', bind);
})();
